import { render } from "./archived_staff.vue?vue&type=template&id=492d9971"
import script from "./archived_staff.vue?vue&type=script&lang=js"
export * from "./archived_staff.vue?vue&type=script&lang=js"

import "./archived_staff.vue?vue&type=style&index=0&id=492d9971&lang=css"

import exportComponent from "D:\\SchoolManagement-Vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__